videojs.addLanguage('en', {
      "Play": "Play",
      "Pause": "Pause",
      "Current Time": "Current Time",
      "Duration Time": "Duration Time",
      "Remaining Time": "Remaining Time",
      "Stream Type": "Stream Type",
      "LIVE": "LIVE",
      "Loaded": "Loaded",
      "Progress": "Progress",
      "Fullscreen": "Fullscreen",
      "Non-Fullscreen": "Non-Fullscreen",
      "Mute": "Mute",
      "Volume": "Volume",
      "Unmute": "Unmute",
      "Playback Rate": "Playback Rate",
      "Subtitles": "Subtitles",
      "subtitles off": "subtitles off",
      "Captions": "Captions",
      "captions off": "captions off",
      "Chapters": "Chapters",
      "Close Modal Dialog": "Close Modal Dialog",
      "Descriptions": "Descriptions",
      "descriptions off": "descriptions off",
      "You aborted the media playback": "You aborted the media playback",
      "A network error caused the media download to fail part-way.": "A network error caused the media download to fail part-way.",
      "The media could not be loaded, either because the server or network failed or because the format is not supported.": "The media could not be loaded, either because the server or network failed or because the format is not supported. Please use another browser, or try again later.",
      "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
      "No compatible source was found for this media.": "No compatible source was found for this media.",
      "No compatible source was found for this DASH media.": function() {
            var ua = navigator.userAgent,
                  is_desktop = !/(iPhone|iPod|iPad|Android|BlackBerry|IEMobile|GoogleTV|Smart-?TV|AppleTV|Mobile|Kindle|Dolfin|Dolphin)/i.test(ua),
                  text = 'DRM error';

            var link = document.createElement('a');
            link.href = "//google.ru/chrome/";
            link.target = "_blank";
            link.textContent = "Chrome";
            link.setAttribute('class', 'vjs-error-display-link');

            var chrome_btn = document.createElement('a');
            chrome_btn.href = "//google.ru/chrome/";
            chrome_btn.target = "_blank";
            chrome_btn.setAttribute('class', 'vjs-error-display-browser-btn');
            var chrome_icon = document.createElement('span');
            chrome_icon.setAttribute('class', 'vjs-error-display-bb-chrome');
            var chrome_txt = document.createElement('span');
            chrome_txt.textContent = " Download Chrome";
            chrome_btn.appendChild(chrome_icon);
            chrome_btn.appendChild(chrome_txt);

            if (is_desktop || /Android (?![1-3])/i.test(ua)) {// >= 4.0
                  text = [document.createTextNode("Sorry, your browser is not supported. "), document.createElement("br"), document.createTextNode(" Use browser "), link, document.createTextNode("."), document.createElement("br"), chrome_btn];
            } else {
                  var face_icon = document.createElement('span');
                  face_icon.setAttribute('class', 'vjs-error-display-face-icon');

                  text = [face_icon, document.createElement("br"), document.createTextNode("Sorry, playpack is only avaliable on Android OS version 4.0 and higher, desktop or Mac.")];
            } 
            return text;
      },
      "Play Video": "Play Video",
      "Close": "Close",
      "Modal Window": "Modal Window",
      "This is a modal window": "This is a modal window",
      "This modal can be closed by pressing the Escape key or activating the close button.": "This modal can be closed by pressing the Escape key or activating the close button.",
      ", opens captions settings dialog": ", opens captions settings dialog",
      ", opens subtitles settings dialog": ", opens subtitles settings dialog",
      ", opens descriptions settings dialog": ", opens descriptions settings dialog",
      ", selected": "selected",
      /* suggested video */
      "You may also like": "You may also like",
      "Viewers": function(viewersCount) {
            if (viewersCount == 1) return 'viewer';
            return 'viewers';
      }
});